$(document).ready(function() {
  var intervalId = setInterval(function() {
   
$(".access-control-entry-options").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".access-control-entry-options .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".access-control-entry-options").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".access-control-entry-options").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".access-control-entry-options").find("#checkboxes");
  checkboxes.toggle();
});

$('.access-control-entry-options .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".access-control-entry-options").find(".mw-option__media");
  $(this).closest(".access-control-entry-options").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.access-control-entry-options').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
});


      //end Contemporary Double Swing & Sliding Gates(access control entry options)

      // Contemporary Double Swing & Sliding Gates(access control exit options)
      $(".access-control-exit-options").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".access-control-exit-options .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".access-control-exit-options").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".access-control-exit-options").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".access-control-exit-options").find("#checkboxes");
  checkboxes.toggle();
});

$('.access-control-exit-options .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".access-control-exit-options").find(".mw-option__media");
  $(this).closest(".access-control-exit-options").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.access-control-exit-options').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
  
});

      // end Contemporary Double Swing & Sliding Gates(access control exit options)

    // start post size
      
$(".post-size").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".post-size .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".post-size").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".post-size").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".post-size").find("#checkboxes");
  checkboxes.toggle();
});

$('.post-size .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".post-size").find(".mw-option__media");
  $(this).closest(".post-size").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.post-size').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
});

    // end post size
// gate stop


$(".gate-stop").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".gate-stop .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".gate-stop").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".gate-stop").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".gate-stop").find("#checkboxes");
  checkboxes.toggle();
});

$('.gate-stop .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".gate-stop").find(".mw-option__media");
  $(this).closest(".gate-stop").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.gate-stop').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
});











// end gate stop




// gate opening kit


$(".gate-opening-kit").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".gate-opening-kit .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".gate-opening-kit").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".gate-opening-kit").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".gate-opening-kit").find("#checkboxes");
  checkboxes.toggle();
});

$('.gate-opening-kit .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".gate-opening-kit").find(".mw-option__media");
  $(this).closest(".gate-opening-kit").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.gate-opening-kit').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
});


// end gate opening kit

// access control fobs

$(".access-control-fobs").append(`<div class="classFound multiselect">
  <div class="selectBox">
    <select>
      <option>-- Please Choose --</option>
    </select>
    <div class="overSelect"></div>
  </div>
  <div id="checkboxes"></div>
  <div class="c-select-box-image-container"></div>
</div>`);

$(".access-control-fobs .multiselect .selectBox").click(function () {
  var labels = $(this).closest(".access-control-fobs").find(".mw-option__value");
  console.log(labels);
  labels.show();
  $(this).closest(".access-control-fobs").find("#checkboxes").append(labels);
  var checkboxes = $(this).closest(".access-control-fobs").find("#checkboxes");
  checkboxes.toggle();
});

$('.access-control-fobs .mw-option__value input[type="checkbox"]').click(function () {
  var imgInfo = $(this).closest(".access-control-fobs").find(".mw-option__media");
  $(this).closest(".access-control-fobs").find(".c-select-box-image-container").append(imgInfo);
  var imgId = $(this).closest(".mw-option__value").attr("data-value-id");
  var images = $(this).closest('.access-control-fobs').find('.mw-option__media[data-value-id="' + imgId + '"]');
  images.toggle();
});




// end access control fobs


    // moving i button text direction to right


    $(".mw-option--type-checkbox .mw-option__value-title").attr("data-mw-tooltip-placement", "right");


    // end moving i button text direction to right

    
// adding i button to the checkboxes
  
 $('.mw-option--type-checkbox .mw-option__value-title').each(function() {
  if ($(this).attr('data-mw-tooltip')) {
    $(this).append(`<span class="mw-tooltip--icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" focusable="false" aria-hidden="true"> <path fill="currentColor" d="M10 0C4.486 0 0 4.486 0 10s4.486 10 10 10 10-4.486 10-10S15.514 0 10 0m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-4.1a1.1 1.1 0 1 0 .001 2.201A1.1 1.1 0 0 0 10 13.9M10 4C8.625 4 7.425 5.161 7.293 5.293A1.001 1.001 0 0 0 8.704 6.71C8.995 6.424 9.608 6 10 6a1.001 1.001 0 0 1 .591 1.808C9.58 8.548 9 9.616 9 10.737V11a1 1 0 1 0 2 0v-.263c0-.653.484-1.105.773-1.317A3.013 3.013 0 0 0 13 7c0-1.654-1.346-3-3-3"></path> </svg> </span>`);
    
  } else {
    console.log("I button not found");
  }
});



    // end adding i button

  // hover on i button
$(".mw-tooltip--icon").hover(
  function () {
    $(this).closest(".mw-option--type-checkbox").find(".mw-tippy").css("opacity", "1");
  },
  function () {
    var $mwTippy = $(this).closest(".mw-option--type-checkbox").find(".mw-tippy");
    var timeoutId = setTimeout(function() {
      var isHovered = $mwTippy.is(":hover"); // Check if the mw-tippy element is being hovered
      if (!isHovered) {
        $mwTippy.css("opacity", "0");
        $("body").trigger("click"); // Trigger a click event on the body element
      }
    }, 100);
    
    $mwTippy.on("mouseenter", function() {
      clearTimeout(timeoutId); // Clear the previous setTimeout when the mw-tippy is hovered again
    });
  }
);


  


  // end hover on i button


    // hover on tooltip content

    // end hover on tooltip content
    

    if ($('*').hasClass('classFound')) {
      clearInterval(intervalId);
    }
  }, 1000);




  

 
  
// end document ready function
});  




